import gql from 'graphql-tag';

import type { BlogOutlineSection } from 'src/data/blog';
import { executeGqlMutation } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_PROJECT_BLOG_CONTENT_OUTLINE_SECTION } from './schema';

const MUTATION = gql`
  mutation CreateBlogPostBuilderAllOutlineSections(
    $projectId: ID!
    $sections: [BlogPostBuilderOutlineSectionInput!]!
  ) {
    createBlogPostBuilderAllOutlineSections(projectId: $projectId, sections: $sections) {
      ...BlogPostBuilderOutlineSection
    }
  }
  ${FRAGMENT_PROJECT_BLOG_CONTENT_OUTLINE_SECTION}
`;

interface Params {
  projectId: ID;
  sections: BlogOutlineSection[];
}

export const createBlogPostBuilderAllOutlineSections = async ({ projectId, sections }: Params) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: { projectId, sections },
  });

  return getSingleProp<BlogOutlineSection[]>(result.data);
};
